import React from 'react';
import 'twin.macro';
import { Links } from 'containers/CahierJournal/DayColumn/Seance/CJEventBody/Links';
import HtmlViewer from '@teetsh/app/src/components/HtmlViewer';
import { CJEvent } from '@teetsh/app/src/types/event';
import { BOLabels } from '@teetsh/app/src/types/user';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { useFieldsToDisplay } from 'containers/CahierJournal/Toolbar/Filters/FieldsToDisplay/atom';

interface Props {
  event: CJEvent;
  boLabels: BOLabels;
  print: boolean;
  userId: string;
  onChange: (v: CJEvent) => void;
}

export const Flow = styled.div`
  word-break: break-word;
  white-space: pre-line;

  > ul {
    padding-left: 1rem;
  }

  @media print {
    > ul {
      padding-left: 0;
      list-style-position: inside;
    }
  }

  p {
    margin-bottom: 0;
  }
`;

export function getLinkedFdpLinkUrl({
  print,
  sequenceId,
  fdpId,
  userId,
}: {
  print: boolean;
  sequenceId?: string;
  fdpId: string;
  userId: string;
}) {
  if (print) {
    if (!sequenceId) {
      return `/users/${userId}/fiches-de-prep/${fdpId}/print`;
    }
    return `/users/${userId}/sequences/${sequenceId}/fiches-de-prep/${fdpId}/print`;
  }
  return `/sequences/${sequenceId}/fiches-de-prep/${fdpId}`;
}

export function Activities(props: Props) {
  const { event, boLabels, print, userId } = props;
  const { flow } = event;
  const fieldsToDisplay = useFieldsToDisplay();
  const linkedFichesDePrep =
    event.linkedFichesDePrep === null ? [] : event.linkedFichesDePrep || [];
  const linkedFichesDePrepToDisplay = linkedFichesDePrep.filter(
    a => typeof a.label === 'string',
  );
  const { t } = useTranslation(['cahierJournal']);
  return (
    <>
      {flow &&
        fieldsToDisplay?.includes('Activités') &&
        boLabels.activitiesName !== '' && (
          <span tw="font-bold">{boLabels.activitiesName} :</span>
        )}
      {flow && fieldsToDisplay?.includes('Activités') && (
        <Flow className="flow" tw="mb-1">
          <HtmlViewer
            text={flow}
            onChange={v => props.onChange({ ...event, flow: v })}
            print={print}
          />
        </Flow>
      )}

      {print &&
        fieldsToDisplay?.includes('fichesDePrep') &&
        linkedFichesDePrepToDisplay.length > 0 && (
          <Links
            items={linkedFichesDePrepToDisplay.map(a => ({
              ...a,
              internalLink: getLinkedFdpLinkUrl({
                print,
                sequenceId: a.sequenceId,
                fdpId: a.id,
                userId,
              }),
            }))}
            label={t('cahierJournal:ficheDePrepLabel_one')}
            labelPlural={t('cahierJournal:ficheDePrepLabel_other')}
          />
        )}
    </>
  );
}
